import {
  Box,
  Button,
  Fieldset,
  Flex,
  Grid,
  Tabs,
  Text,
  Title,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { CustomerGroup } from "../../../../model/TblDmCustomer";
import {
  listBranch,
  listFlashSaleTime,
  tblPromotion,
  tblPromotionDetailModel,
  tblPromotionItemAddOnCommand,
  tblPromotionItemGiftCommand,
  tblPromotionItemPrimaryCommand,
} from "../../../../model/TblPromotion";
import { TblPromotionConditionMultipleModel } from "../../../../model/TblPromotionConditionMultiple";
import GeneralInformation from "./Components/GeneralInformation/GeneralInformation";
import Customers from "./Components/SetupPromotionPolicy/Customers";
import SaleChannel from "./Components/SetupPromotionPolicy/SaleChannel";
import SuperMarket from "./Components/SetupPromotionPolicy/SuperMarket";
import TableItemAddOnPromotion from "./Components/TableItemPromotion/TableItemAddOnPromotion";
import TableItemGiftPromotion from "./Components/TableItemPromotion/TableItemGiftPromotion";
import TableItemPrimaryPromotion from "./Components/TableItemPromotion/TableItemPrimaryPromotion";
import TypePromotionPolicy from "./Modals/TypePromotionPolicy";
import { PromotionalDescriptionV2 } from "../CreatePromotionPolicy/Components/TableItemPromotion/PromotionalDescriptionV2";

const ViewDetailPromotion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state && location.state.id;
  const type = location.state && location.state.type; //gồm có single và multi
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedPolicyType, setSelectedPolicyType] = useState<string>("0");
  const [dataPromotionDetail, setDataPromotionDetail] =
    useState<tblPromotionDetailModel>();
  const [dataPromotionItemPrimaryModels, setDataPromotionItemPrimaryModels] =
    useState<tblPromotionItemPrimaryCommand[]>([]);
  const [dataPromotionItemGiftModels, setDataPromotionItemGiftModels] =
    useState<tblPromotionItemGiftCommand[]>([]);
  const [dataPromotionItemAddOnModels, setDataPromotionItemAddOnModels] =
    useState<tblPromotionItemAddOnCommand[]>([]);
  const [successCall, setSuccessCall] = useState<boolean>(false);
  // const backHome = () => {
  //   navigate("/config-system/config-promotion-policy");
  //   localStorage.removeItem("policyType");
  // };

  const [promotionConditionMultiples, setPromotionConditionMultiples] =
    useState<TblPromotionConditionMultipleModel[]>([]);

  const openTypePP = () => {
    setModalOpened(true);
    modals.openConfirmModal({
      size: "auto",
      centered: true,
      title: (
        <>
          <Title order={5}>Chọn loại chính sách khuyến mại</Title>
        </>
      ),
      children: (
        <TypePromotionPolicy
          setSelectedPolicyType={setSelectedPolicyType}
          backHome={() => navigate(-1)}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dataApi, dataApiGift, dataApiAddOn] = await Promise.all([
          repositoryPos.post<MessageResponse<tblPromotion>>(
            `/api/v1/TblPromotion/detail?id=${id}`
          ),
          repositoryPos.get<MessageResponse<tblPromotionItemGiftCommand[]>>(
            `/api/v1/TblPromotion/get-list-gift?PromotionId=${id}&Skip=0&Take=1000`
          ),
          repositoryPos.get<MessageResponse<tblPromotionItemAddOnCommand[]>>(
            `/api/v1/TblPromotion/get-list-add-on?PromotionId=${id}&Skip=0&Take=1000`
          ),
        ]);
        if (dataApi && dataApi.success) {
          let listBranch: string | null = null;
          let listPaymentMethod: string[] | string | null = [];
          let listSaleChanel: string | string[] | null = [];
          let listFlashSaleTime: listFlashSaleTime[] = [];
          let listGroup: CustomerGroup[] = [];
          let countDownDate = null;

          setSuccessCall(true);

          // Giữ nguyên chuỗi id, SuperMarket tự tra tên chi nhánh từ danh mục
          listBranch = dataApi.data.tblPromotionDetailModel?.listBranch ?? null;
          if (
            dataApi.data.tblPromotionDetailModel?.listPaymentMethod &&
            dataApi.data.tblPromotionDetailModel?.listPaymentMethod?.includes(
              ","
            )
          ) {
            listPaymentMethod = String(
              dataApi.data.tblPromotionDetailModel?.listPaymentMethod
            ).split(",");
          } else {
            listPaymentMethod = dataApi.data.tblPromotionDetailModel
              ?.listPaymentMethod
              ? [
                  String(
                    dataApi.data.tblPromotionDetailModel?.listPaymentMethod
                  ),
                ]
              : [];
          }

          if (
            dataApi.data.tblPromotionDetailModel?.listSaleChanel &&
            dataApi.data.tblPromotionDetailModel?.listSaleChanel?.includes(",")
          ) {
            listSaleChanel = String(
              dataApi.data.tblPromotionDetailModel?.listSaleChanel
            ).split(",");
          } else {
            listSaleChanel = dataApi.data.tblPromotionDetailModel
              ?.listSaleChanel
              ? [String(dataApi.data.tblPromotionDetailModel?.listSaleChanel)]
              : [];
          }
          // if (dataApi.data.tblPromotionDetailModel?.listFlashSaleTime) {
          //   listFlashSaleTime = JSON.parse(
          //     dataApi.data.tblPromotionDetailModel?.listFlashSaleTime as string
          //   );
          // }
          if (dataApi.data.tblPromotionDetailModel?.listCustGroup) {
            listGroup = JSON.parse(
              dataApi.data.tblPromotionDetailModel?.listCustGroup as string
            );
          }

          if (dataApi.data.tblPromotionDetailModel?.countDownDate) {
            countDownDate = dataApi.data?.tblPromotionDetailModel?.countDownDate
              ? new Date(dataApi.data?.tblPromotionDetailModel?.countDownDate)
              : null;
          }

          setDataPromotionDetail({
            ...dataApi.data.tblPromotionDetailModel!,
            listBranch: listBranch,
            listCustGroup: listGroup,
            countDownDate: countDownDate ? new Date(countDownDate ?? "") : null,
            listPaymentMethod: listPaymentMethod,
            listSaleChanel: listSaleChanel,
            //  listFlashSaleTime: listFlashSaleTime,
          });

          setDataPromotionItemPrimaryModels(
            dataApi.data.tblPromotionItemPrimaryModels || []
          );

          setSelectedPolicyType(
            dataApi.data.tblPromotionDetailModel?.type || "0"
          );
        } else NotificationExtension.Fails("Không có dữ liệu");

        if (dataApiAddOn && dataApiAddOn.success) {
          setDataPromotionItemAddOnModels(dataApiAddOn.data || []);
        }

        if (dataApiGift && dataApiGift.success) {
          setDataPromotionItemGiftModels(dataApiGift.data || []);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();

    // if (!localStorage.getItem("policyType")) {
    //   openTypePP();
    // }
  }, []);

  console.log(dataPromotionDetail?.moTa, "dataPromotionDetail121212");

  return (
    <Box>
      <Flex align={"center"} gap={"md"} justify={"space-between"}>
        <Text size={"16px"} tt={"uppercase"} fw={"bold"}>
          Xem chi tiết chính sách khuyến mãi
        </Text>
        <Button
          variant="outline"
          color="gray"
          leftSection={<IconWindow size={14} />}
          // size="xs"
          onClick={() => navigate(-1)}
        >
          Đóng
        </Button>
      </Flex>
      <Grid>
        <Grid.Col
          // span={{ base: 12, md: 6, lg: 5 }}
          span={12}
          h={"max-content"}
        >
          <GeneralInformation dataPromotionDetail={dataPromotionDetail} />
        </Grid.Col>
        {/* <Grid.Col span={{ base: 12, md: 6, lg: 7 }} h={"max-content"}>
          <SetupPromotionPolicy form={form} />
        </Grid.Col> */}
        <Grid.Col span={12}>
          <Tabs
            defaultValue={"primary"}
            styles={{
              tabLabel: {
                fontWeight: 700,
                fontSize: 13,
              },
              panel: {
                overflowX: "visible",
              },
            }}
          >
            <Tabs.List>
              {/* <Tabs.Tab value="otherConditions">Điều kiện khác</Tabs.Tab> */}
              <Tabs.Tab value="primary">Mặt hàng chính</Tabs.Tab>{" "}
              {/* <Tabs.Tab value="1a">Danh sách mặt hàng không áp dụng</Tabs.Tab> */}
              {dataPromotionDetail?.type === "1" ? (
                <>
                  <Tabs.Tab value="gift">Mặt hàng tặng</Tabs.Tab>
                  <Tabs.Tab value="addOn">Mặt hàng mua kèm</Tabs.Tab>
                </>
              ) : (
                <></>
              )}
              <Tabs.Tab value="branch&customer">
                Chi nhánh áp dụng và khách hàng
              </Tabs.Tab>
              <Tabs.Tab value="PromotionDescription">Mô tả khuyến mãi</Tabs.Tab>
              {/* <Tabs.Tab value="time&pay">
                Thời gian và phương thức thanh toán
              </Tabs.Tab> */}
            </Tabs.List>

            <Tabs.Panel value="primary">
              <TableItemPrimaryPromotion
                dataPromotionItemPrimaryModels={dataPromotionItemPrimaryModels}
                typePromotion={dataPromotionDetail?.type ?? ""}
              />
            </Tabs.Panel>
            <Tabs.Panel value="gift">
              <TableItemGiftPromotion
                dataPromotionItemGiftModels={dataPromotionItemGiftModels}
              />
            </Tabs.Panel>
            <Tabs.Panel value="addOn">
              <TableItemAddOnPromotion
                dataPromotionItemAddOnModels={dataPromotionItemAddOnModels}
              />
            </Tabs.Panel>

            <Tabs.Panel value="branch&customer">
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend={"Chi nhánh áp dụng"} mt={10}>
                    <SuperMarket dataPromotionDetail={dataPromotionDetail} />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend="Đối tượng khách hàng" mt={10}>
                    <Customers
                      data={
                        dataPromotionDetail?.listCustGroup as CustomerGroup[]
                      }
                    />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Fieldset legend="Kênh bán áp dụng" mt={10}>
                    <SaleChannel
                      data={dataPromotionDetail?.listSaleChanel}
                      successCall={successCall}
                    />
                  </Fieldset>
                </Grid.Col>
              </Grid>
            </Tabs.Panel>
            <Tabs.Panel value="PromotionDescription">
              <PromotionalDescriptionV2
                dataPromotionDetail={{
                  data: dataPromotionDetail
                    ? {
                        ...dataPromotionDetail,
                        htmlDescription:
                          (dataPromotionDetail as any).moTa ??
                          dataPromotionDetail.htmlDescription,
                      }
                    : undefined,
                  method: "DETAIL",
                }}
              />
            </Tabs.Panel>
            {/* <Tabs.Panel value="time&pay">
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Fieldset legend="Thời gian áp dụng" mt={10}>
                    <TimeApplication
                      dataPromotionDetail={dataPromotionDetail}
                    />
                  </Fieldset>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Fieldset legend="Thanh toán" mt={10}>
                    <Pay dataPromotionDetail={dataPromotionDetail} />
                  </Fieldset>
                </Grid.Col>
              </Grid>
            </Tabs.Panel> */}
          </Tabs>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default ViewDetailPromotion;
